import {Store, useStore} from 'vuex';
import {TextBlock} from '../../../app/src/types';
import {computed} from 'vue';

export function useTextBlocks() {

    const store: Store<TextBlock> = useStore();
    const textBlocks = computed<TextBlock[]>(() => store.getters['textBlocks/textBlocks']);

    return {
        textBlocks,
    };
}
